import { useMutation, useQueryClient } from '@tanstack/react-query';
import { payoutService } from '../services/payout.service';
import { ONBOARDING_STATUS_KEY } from './use-onboarding-status';

export function useStartOnboarding() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (returnUrl?: string) => payoutService.startOnboarding(returnUrl),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ONBOARDING_STATUS_KEY });
    },
  });
}
